/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:53:57
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import { Title9 } from '../components/Titles';
import Form from './Form';
import TooltipDrawer from '../components/TooltipDrawer';
import DBTable from '../components/DBTable';
import { merge } from 'lodash';
import { applyThousands } from '../utils';

class p22 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  createColumns = () => {
    const { tableColumns, tableColorList } = this.state;

    return tableColumns.map((item, columnIndex) => {
      const result = merge({}, item, {
        style: {
          background: tableColorList[0],
          color: tableColorList[1],
          borderBottom: `2px solid ${tableColorList[2]}`
        },
        colStyle: (_, _i, index) => {
          const left = index === 0 ? { borderLeft: `2px solid ${tableColorList[2]}` } : {}
          return {
            ...item.colStyle,
            ...left,
            background: '#fff',
            borderRight: `2px solid ${tableColorList[2]}`,
            borderBottom: `2px solid ${tableColorList[2]}`,
          }
        },
      })

      if (columnIndex === 0) {
        result.mergeRow = true;
      }

      if (columnIndex > 2) {
        result.render = (value) => {
          return (
            <div className={s.progress}>
              <div className={s.progressText}>{value}</div>
              <div className={s.progressInner} style={{ width: `${parseFloat(value)}%`, backgroundColor: tableColorList[columnIndex] }} />
            </div>
          )
        }
      }

      return result;
    })
  }

  render() {
    const { tableList } = this.state;
    return (
      <Stage>
        <Title9 pageNumber="6">各平台五级情感倾向分析</Title9>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>各平台负面口碑均过半数，社交媒体为重灾区，企鹅号相对友好</div>
            <div contentEditable className={s.desWrapper}>
              <div className={s.des}>
                整体来看，口碑以负面为主，各平台的负面占比均过半。
              </div>
              <div className={s.des}>
                各平台口碑均有两级分化的趋势，即反感与推荐内容较多，其他情感级别占比较少。
              </div>
              <div className={s.des}>
                分平台来看，社交媒体负面口碑最严重，微博知乎反感比例为全网最高，而推荐比例较低。
              </div>
              <div className={s.des}>
                细分平台中，同花顺财经与企鹅号友好程度最高，反感相对较少，推荐相对较多。
              </div>
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.createColumns()} data={applyThousands(tableList)} />
              </TooltipDrawer>
            </div>
          </div>
          <div contentEditable className={s.explain}>数据说明：本页图表数据观测窗口为2021年1月1日-11月30日，数据来源：新闻网站类+自媒体平台（微信号等）+社交平台（微博/知乎等）+新闻客户端（今日头条/一点资讯等）+短视频类（抖音/快手/B站）+股票平台（雪球/东方财富网/同花顺财经/富途）+其它论坛贴吧等。</div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(p22);



// WEBPACK FOOTER //
// src/routes/visualChart/P22/index.js